import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import RuntimeException from '../../../../java/lang/RuntimeException';
var AssertionFailedException = /*#__PURE__*/function (_RuntimeException) {
  _inherits(AssertionFailedException, _RuntimeException);
  function AssertionFailedException() {
    var _this;
    _classCallCheck(this, AssertionFailedException);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(AssertionFailedException).call(this));
    AssertionFailedException.constructor_.apply(_assertThisInitialized(_assertThisInitialized(_this)), arguments);
    return _this;
  }
  _createClass(AssertionFailedException, null, [{
    key: "constructor_",
    value: function constructor_() {
      if (arguments.length === 0) {
        RuntimeException.constructor_.call(this);
      } else if (arguments.length === 1) {
        var message = arguments[0];
        RuntimeException.constructor_.call(this, message);
      }
    }
  }]);
  return AssertionFailedException;
}(RuntimeException);
export { AssertionFailedException as default };